import { uniq } from "lodash-es";

import { FilterDefinitionItem } from "@/common/filters/filterDefinitionItem";
import { GeneralTagDtoUnion } from "@/common/ts/dto";
import {
  GeneralAttachedTagsInputDto,
  GeneralAttachedTagsQueryDto,
  TagStaticFilterDto,
} from "@/core/api/generated/v1";

export type TagStaticFilterInputDto = Omit<TagStaticFilterDto, "query"> & {
  query?: GeneralAttachedTagsInputDto;
};

export class TagsHelper {
  public static isExternalForCurrentTenant(params: {
    currentTenantId: Nil<string>;
    tag: Nil<GeneralTagDtoUnion>;
  }): boolean {
    return (
      !!params.tag?.isExternalTarget &&
      !!params.tag?.target?.tenantId &&
      params.tag.target?.tenantId !== params.currentTenantId
    );
  }

  public static mapToQueryDto(
    value: GeneralAttachedTagsInputDto | undefined,
  ): GeneralAttachedTagsQueryDto | undefined {
    return (
      value && {
        targetIds: uniq(value.tags?.map((x) => x.target?.targetId || "").filter(Boolean)),
      }
    );
  }

  public static mapFromFilter(filter: FilterDefinitionItem): TagStaticFilterDto | undefined {
    return {
      operator: filter.operator,
      query: filter.value
        ? this.mapToQueryDto(filter.value as GeneralAttachedTagsInputDto)
        : undefined,
    } as TagStaticFilterDto;
  }
}
